/**
 * 判断 user_ask 卡片在 chat 流的渲染形态.
 *
 * - 'inline' — chat 流内 UserAskBlock 完整卡片 (留在原位)
 * - 'chip'   — chat 流轻量 chip + 底部 ActionSheet 独立层 (重交互避免淹没)
 *
 * 默认 'chip' (新协议所有 user_ask 都走 ActionSheet 独立层).
 * 特例白名单: title 命中关键词的 ask 保留 chat 流 inline 形态 — 当前仅
 * "保存模板"场景 (LLM 在填表结束时主动 ask "是否保存为可复用模板").
 *
 * ⚠ 用 title 关键词匹配是临时方案,后续后端 prompt 可在 user_ask tool 调用时
 * 显式传 display='inline' 字段做更稳的协议层分流.
 */
const INLINE_TITLE_PATTERNS: RegExp[] = [
  /保存.*模板/, // 例: "把这次的填表方法保存成模板?"
  /保存.*技能/ // 备选: LLM 可能用"技能/能力"等别名
]

export function pickUserAskDisplayAs(
  questions: unknown,
  title?: unknown
): 'inline' | 'chip' {
  if (typeof title === 'string' && title.trim()) {
    if (INLINE_TITLE_PATTERNS.some((re) => re.test(title))) {
      return 'inline'
    }
  }
  return 'chip'
}
